import React from "react";

 function Projects() {
  return (
    <section className="w3-container">
      <h2 className="w3-center w3-container__title">My Projects</h2>
      <p className="w3-center w3-container__subtitle">Please feel free to check my projects on GitHub by clicking on any of them</p>
    </section>
  );
}

export default Projects;
